import type { ReactNode } from "react";

import "./Badge.css";

type Tone = "default" | "subtle" | "primary";

const CLASS: Record<Tone, string> = {
  default: "nav-badge",
  subtle: "nav-badge subtle",
  primary: "nav-badge primary",
};

export function Badge({ tone = "default", children }: { tone?: Tone; children: ReactNode }) {
  return <span className={CLASS[tone]}>{children}</span>;
}
